import { render, staticRenderFns } from "./publish-footer.vue?vue&type=template&id=28755fc6&scoped=true"
import script from "./publish-footer.vue?vue&type=script&lang=js"
export * from "./publish-footer.vue?vue&type=script&lang=js"
import style0 from "./publish-footer.vue?vue&type=style&index=0&id=28755fc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28755fc6",
  null
  
)

export default component.exports